import { useEffect, useState } from 'react'
import { db } from '../firebase/config'

// Live subscription on the singleton PlatformStats/current doc — the nightly
// platform-wide aggregates (computePlatformStats). Deliberate exception to
// #database-missing-compagnyid-on-fresh-fetch: this is a doc-ID read of a
// system-level singleton, not a query on a tenant collection — there is no
// CompagnyID to scope by and no Deleted lifecycle (the nightly job only ever
// merge-overwrites it). Reading requires auth (Console rule); the cards using
// this hook are additionally gated to the Deccos management tenant.
//
// AI-CONTEXT: See docs/features/supertenant-dashboard-cards.md
const usePlatformStats = () => {
    const [stats, setStats] = useState(/** @type {object | null} */ (null))
    const [loading, setLoading] = useState(true)

    useEffect(() => {
        const unsubscribe = db.collection('PlatformStats').doc('current').onSnapshot(
            (snapshot) => {
                setStats(snapshot.exists ? snapshot.data() : null)
                setLoading(false)
            },
            (error) => {
                console.error('usePlatformStats error:', error)
                setStats(null)
                setLoading(false)
            },
        )
        return unsubscribe
    }, [])

    return { stats, loading }
}

export default usePlatformStats
